import axios from "axios";

import { deleteStoredUser, getStoredUser } from "../redux/utils";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:8000",
});

api.interceptors.request.use(
  function (config) {
    const user = getStoredUser();
    if (user) {
      config.headers.Authorization = `Bearer ${user.access}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    if (error.response?.status === 401) {
      deleteStoredUser();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default api;
